<template>
  <div>
    <v-app-bar absolute color="primary" elevate-on-scroll dark app>
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <v-toolbar-title>Dashboard</v-toolbar-title>

      <div class="hidden-md-and-down ml-10">
        <v-btn text to="/opendata" dark> Data Terkini </v-btn>

        <v-btn class="ml-5" text to="/auth" dark> id ASN </v-btn>
      </div>

      <v-spacer></v-spacer>

      <div>
        <v-icon left color="white">mdi-calendar</v-icon>
        {{ ftanggal(Date.now()) }}
      </div>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list dense nav shaped>
        <v-list-item to="/opendata" link color="primary">
          <v-list-item-content>
            <v-list-item-title> DATA TERKINI </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/auth" link color="primary">
          <v-list-item-content>
            <v-list-item-title> ID ASN </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main class="grey lighten-3 mt-5 pb-10">
      <v-container fluid>
        <div class="mb-5">
          <v-row>
            <v-col cols="12" md="6">
              <v-card class="pa-4">
                <v-row>
                  <v-col cols="3" md="2">
                    <v-img src="@/assets/gambar/logo.png"></v-img>
                  </v-col>
                  <v-col cols="12" md="10" class="my-auto">
                    <div class="font-weight-black">
                      <h1>PEMERINTAH KABUPATEN POHUWATO</h1>
                    </div>

                    <div class="font-weight-light font-italic">
                      <h3 class="text--secondary">
                        Integrated Database Aparatur Sipil Negara
                      </h3>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="3" v-if="data_asn">
              <v-card class="pa-2" color="#FFF9C4">
                <v-row>
                  <v-col cols="12" md="4" class="text-center">
                    <v-icon size="100" color="dark">mdi-chart-arc</v-icon>
                  </v-col>
                  <v-col cols="12" md="8" class="my-auto">
                    <div class="font-weight-black">
                      Jumlah ASN {{ fangka(total_asn) }}
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <div v-for="item in data_asn" :key="item.status_asn">
                      <v-row>
                        <v-col cols="6">
                          {{ item.status_asn }}
                        </v-col>
                        <v-col cols="6">
                          {{ fangka(item.jumlah) }}
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="3">
              <v-card class="pa-2" color="#AD1457" dark>
                <v-row>
                  <v-col cols="12" md="4" class="text-center">
                    <v-icon size="100" color="dark">mdi-chart-arc</v-icon>
                  </v-col>
                  <v-col cols="12" md="8" class="my-auto">
                    <div class="font-weight-black">Jumlah ASN MPP 1 Tahun</div>

                    <v-divider class="my-3"></v-divider>

                    <div>
                      <v-row class="mb-n6">
                        <v-col cols="6"> PNS </v-col>
                        <v-col cols="6"> 0 </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6"> PPPK </v-col>
                        <v-col cols="6"> 0 </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <div class="mb-5" v-if="data_jabatan">
          <v-row>
            <v-col
              cols="12"
              md="3"
              v-for="item in data_jabatan.jabatan"
              :key="item.status_jabatan"
            >
              <v-card
                class="pa-3"
                color="#B2EBF2"
                v-if="item.status_jabatan == 'Struktural'"
              >
                <v-row>
                  <v-col cols="9">
                    <div>
                      <h1>{{ fangka(item.jumlah) }}</h1>
                    </div>
                    <div>Jumlah PNS {{ item.status_jabatan }}</div>
                  </v-col>

                  <v-col cols="3" class="my-auto">
                    <v-icon size="65">mdi-account-tie</v-icon>
                  </v-col>

                  <v-col cols="12" style="background-color: #00acc1">
                    <div class="text-center white--text">
                      PNS JPT/ Administrator / Pengawas
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="pa-3"
                color="#DCEDC8"
                v-if="item.status_jabatan == 'Fungsional'"
              >
                <v-row>
                  <v-col cols="9">
                    <div>
                      <h1>{{ fangka(item.jumlah) }}</h1>
                    </div>
                    <div>Jumlah PNS {{ item.status_jabatan }}</div>
                  </v-col>

                  <v-col cols="3" class="my-auto">
                    <v-icon size="65">mdi-account-tie</v-icon>
                  </v-col>

                  <v-col cols="12" style="background-color: #7cb342">
                    <div class="text-center white--text">
                      PNS Dengan Jabatan Fungsional
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="pa-3"
                color="#FFCCBC"
                v-if="item.status_jabatan == 'Pelaksana'"
              >
                <v-row>
                  <v-col cols="9">
                    <div>
                      <h1>{{ fangka(item.jumlah) }}</h1>
                    </div>
                    <div>Jumlah PNS {{ item.status_jabatan }}</div>
                  </v-col>

                  <v-col cols="3" class="my-auto">
                    <v-icon size="65">mdi-account-tie</v-icon>
                  </v-col>

                  <v-col cols="12" style="background-color: #f4511e">
                    <div class="text-center white--text">
                      PNS Dengan Jabatan Pelaksana
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="3">
              <v-card class="pa-3" color="#C5CAE9">
                <v-row>
                  <v-col cols="9">
                    <div>
                      <h1>{{ fangka(data_jabatan.pppk) }}</h1>
                    </div>
                    <div>Jumlah PPPK</div>
                  </v-col>

                  <v-col cols="3" class="my-auto">
                    <v-icon size="65">mdi-account-tie</v-icon>
                  </v-col>

                  <v-col cols="12" style="background-color: #3949ab">
                    <div class="text-center white--text">Jumlah PPPK</div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <div>
          <v-row>
            <v-col cols="12" md="6">
              <v-card class="pa-3">
                <div>
                  <h4>REKAPITULASI PNS MENURUT GOLONGAN RUANG</h4>
                </div>

                <v-divider class="my-3"></v-divider>

                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Jenis Kelamin</th>
                        <th class="text-left">Gol. I</th>
                        <th class="text-left">Gol. II</th>
                        <th class="text-left">Gol. III</th>
                        <th class="text-left">Gol. IV</th>
                        <th class="text-left">Jumlah</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in data_golongan"
                        :key="item.jenis_kelamin"
                      >
                        <td v-if="item.jenis_kelamin">
                          {{ item.jenis_kelamin }}
                        </td>
                        <td v-else class="font-italic">null</td>

                        <td>{{ fangka(item.golongan_I) }}</td>
                        <td>{{ fangka(item.golongan_II) }}</td>
                        <td>{{ fangka(item.golongan_III) }}</td>
                        <td>{{ fangka(item.golongan_IV) }}</td>
                        <td>{{ fangka(item.jumlah) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <v-divider class="my-3"></v-divider>

                <div>
                  <BGolongan />
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card class="pa-3">
                <div>
                  <h4>REKAPITULASI PNS MENURUT TINGKAT PENDIDIKAN</h4>
                </div>

                <v-divider class="my-3"></v-divider>

                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Jenis Kelamin</th>
                        <th class="text-left">SD</th>
                        <th class="text-left">SLTP</th>
                        <th class="text-left">SLTA / D1</th>
                        <th class="text-left">D2 / D3</th>
                        <th class="text-left">S1</th>
                        <th class="text-left">S2</th>
                        <th class="text-left">S3</th>
                        <th class="text-left">Jumlah</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in data_pendidikan"
                        :key="item.jenis_kelamin"
                      >
                        <td v-if="item.jenis_kelamin">
                          {{ item.jenis_kelamin }}
                        </td>
                        <td v-else class="font-italic">null</td>

                        <td>{{ fangka(item.sd) }}</td>
                        <td>{{ fangka(item.sltp) }}</td>
                        <td>{{ fangka(item.slta) }}</td>
                        <td>{{ fangka(item.d3) }}</td>
                        <td>{{ fangka(item.s1) }}</td>
                        <td>{{ fangka(item.s2) }}</td>
                        <td>{{ fangka(item.s3) }}</td>
                        <td>{{ fangka(item.jumlah) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <v-divider class="my-3"></v-divider>

                <div>
                  <BPendidikan />
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import lib from "@/helper/lib.js";

import BGolongan from "@/components/chart/bar-golongan";
import BPendidikan from "@/components/chart/bar-pendidikan";

export default {
  components: {
    BGolongan,
    BPendidikan,
  },

  data: () => ({
    drawer: false,

    total_asn: 0,

    data_asn: [],
    data_jabatan: [],
    data_golongan: [],
    data_pendidikan: [],
  }),

  watch: {
    data_asn() {
      if (this.data_asn.length > 0) {
        this.total_asn = this.data_asn.reduce(
          (sum, item) => sum + item.jumlah,
          0,
        );
      } else {
        this.total_asn = 0;
      }
    },
  },

  async mounted() {
    this.jmlasn();
    this.jmljabatan();
    this.jmlgolongan();
    this.jmlpendidikan();
  },

  methods: {
    ftanggal(value) {
      return lib.tanggal(value);
    },

    fangka(value) {
      return lib.rupiah(value);
    },

    jmlasn() {
      const url = process.env.VUE_APP_ASN + "statistik/jumlah/asn";

      this.http
        .get(url)
        .then((response) => {
          this.data_asn = response.data.data;
        })
        .catch((error) => {
          console.log(error.response.status);
          console.log("Error", error.message);
        });
    },

    jmljabatan() {
      const url = process.env.VUE_APP_ASN + "statistik/jumlah/jabatan";

      this.http
        .get(url)
        .then((response) => {
          this.data_jabatan = response.data.data;
        })
        .catch((error) => {
          console.log(error.response.status);
          console.log("Error", error.message);
        });
    },

    jmlgolongan() {
      const url = process.env.VUE_APP_ASN + "statistik/jumlah/golongan";

      this.http
        .get(url)
        .then((response) => {
          this.data_golongan = response.data.data;
        })
        .catch((error) => {
          console.log(error.response.status);
          console.log("Error", error.message);
        });
    },

    jmlpendidikan() {
      const url = process.env.VUE_APP_ASN + "statistik/jumlah/pendidikan";

      this.http
        .get(url)
        .then((response) => {
          this.data_pendidikan = response.data.data;
        })
        .catch((error) => {
          console.log(error.response.status);
          console.log("Error", error.message);
        });
    },
  },
};
</script>
